"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapsible = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
/**
 * A utility component for showing and hiding content.
 *
 * @since 4.1.0
 */
var Collapsible = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Collapsible, _Component);
  function Collapsible(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          collapsed: !prevState.collapsed
        };
      });
    };
    _this.state = {
      collapsed: props.defaultCollapsed
    };
    return _this;
  }
  var _proto = Collapsible.prototype;
  _proto.render = function render() {
    return this.props.children(this.state.collapsed, this.toggle);
  };
  return Collapsible;
}(_react.Component);
exports.Collapsible = Collapsible;
Collapsible.propTypes = process.env.NODE_ENV !== "production" ? {
  /** `true` if the content should be collapsed to start with */
  defaultCollapsed: _propTypes.default.bool,
  /**
   * A render prop that receives two arguments:
   *     `collapsed`: the current collapsed state,
   *     `toggle`: a callback for when to toggle the collapsed state
   */
  children: _propTypes.default.func.isRequired
} : {};
Collapsible.defaultProps = {
  defaultCollapsed: false
};